<template>
  <div class="step">
    <div class="dot"></div>
    <div class="line" v-if="!noLine"></div>
  </div>
</template>

<script>
export default {
  props:{
    noLine:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.step {
  .dot {
    width: 24px;
    height: 24px;
    background: #0072f7;
    border-radius: 50%;
    z-index: 1;
  }
  .line {
    width: 1px;
    height: 120px;
    background: #eee;
    margin-left: 12px;
    z-index: 0;
  }
}
</style>
